<template>
  <b-container v-if="appTypes" fluid>
    <b-row class="pb-4" :key="index" v-for="(app, index) in appTypes.detail">
      <b-col class="app-types-wrapper" md="6" xl="4" sm="6">
        <div class="d-flex justify-content-start align-items-center pt-2 pb-2">
          <img class="client-logo mr-3" :src="getImagePath(app.app_type)"/>
          <div class="client-name">{{ getClientName(app.app_type) }}</div>
        </div>
        <div class="d-flex justify-content-between align-items-center pl-3 pt-2 pb-2">
          <div>Текущая версия ({{ app.latest }})</div>
          <div v-show="app.app_type === 'main'">
            <i v-show="!mainLoader || ((mainVersion !== null) && (mainVersion !== 'latest'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'latest' })"></i>
            <b-spinner v-show="mainLoader && (mainVersion === 'latest')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_latest'"
               @click="copyTextToClipboard(app.app_type + '_latest', app.latest_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_latest', $event)">
            </i>
          </div>
          <div v-show="app.app_type === 'sea'">
            <i v-show="!seaLoader || ((seaVersion !== null) && (seaVersion !== 'latest'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'latest' })"></i>
            <b-spinner v-show="seaLoader && (seaVersion === 'latest')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_latest'"
               @click="copyTextToClipboard(app.app_type + '_latest', app.latest_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_latest', $event)">
            </i>
          </div>
          <div v-show="app.app_type === 'air'">
            <i v-show="!airLoader || ((airVersion !== null) && (airVersion !== 'latest'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'latest' })"></i>
            <b-spinner v-show="airLoader && (airVersion === 'latest')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_latest'"
               @click="copyTextToClipboard(app.app_type + '_latest', app.latest_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_latest', $event)">
            </i>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center pl-3 pt-2 pb-2">
          <div>Предыдущая версия ({{ app.prev }})</div>
          <div v-show="app.app_type === 'main'">
            <i v-show="!mainLoader || ((mainVersion !== null) && (mainVersion !== 'prev'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'prev' })"></i>
            <b-spinner v-show="mainLoader && (mainVersion === 'prev')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_prev'"
               @click="copyTextToClipboard(app.app_type + '_prev', app.prev_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_prev', $event)">
            </i>
          </div>
          <div v-show="app.app_type === 'sea'">
            <i v-show="!seaLoader || ((seaVersion !== null) && (seaVersion !== 'prev'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'prev' })"></i>
            <b-spinner v-show="seaLoader && (seaVersion === 'prev')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_prev'"
               @click="copyTextToClipboard(app.app_type + '_prev', app.prev_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_prev', $event)">
            </i>
          </div>
          <div v-if="app.app_type === 'air'">
            <i v-if="!airLoader || ((airVersion !== null) && (airVersion !== 'prev'))" v-b-tooltip.hover title="Скачать" class="fas fa-download action mr-2" @click="downloadAppData({ type: app.app_type, version: 'prev' })"></i>
            <b-spinner v-show="airLoader && (airVersion === 'prev')" class="mr-2 action" style="width: 18px; height: 18px;" variant="secondary" type="grow" label="Spinning"></b-spinner>
            <i class="fas fa-copy action"
               :id="app.app_type + '_prev'"
               @click="copyTextToClipboard(app.app_type + '_prev', app.prev_link, $event)"
               v-b-tooltip.hover
               title="Копировать"
               @mouseleave="resetTooltip(app.app_type + '_prev', $event)">
            </i>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'ProductClient',
  data () {
    return {
      mainLoader: false,
      seaLoader: false,
      airLoader: false,
      mainVersion: null,
      seaVersion: null,
      airVersion: null
    }
  },
  mounted () {
    this.getAppTypes()
  },
  computed: {
    ...mapState(
      {
        appTypes: state => state.productClient.appTypes
      }
    )
  },
  methods: {
    ...mapActions('productClient',
      [
        'getAppTypes',
        'getClient'
      ]
    ),
    ...mapMutations({}),
    getImagePath (type) {
      const client = (type === 'main') ? '' : '-' + type
      return require('../assets/ctm-fill-bill' + client + '.png')
    },
    getClientName (type) {
      if (type === 'main') {
        return 'Fill-Bill ОЭЗ/Транзит'
      } else if (type === 'sea') {
        return 'Fill-Bill Порты'
      } else if (type === 'air') {
        return 'Fill-Bill Авиа'
      }
    },
    downloadClient (result) {
      return new Promise((resolve, reject) => {
        try {
          let fileName = result.headers['content-disposition'].split('filename=')[1]
          fileName = fileName.substring(1, fileName.length - 1)
          const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: result.type }))
          const link = document.createElement('a')
          link.href = downloadUrl
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(downloadUrl)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    downloadAppData (data) {
      if (data.type === 'main') {
        this.mainLoader = true
        this.mainVersion = data.version
      } else if (data.type === 'sea') {
        this.seaLoader = true
        this.seaVersion = data.version
      } else if (data.type === 'air') {
        this.airLoader = true
        this.airVersion = data.version
      }
      this.getClient(data).then(
        result => {
          this.downloadClient(result).then(
            () => {
              setTimeout(() => {
                if (data.type === 'main') {
                  this.mainLoader = false
                  this.mainVersion = null
                } else if (data.type === 'sea') {
                  this.seaLoader = false
                  this.seaVersion = null
                } else if (data.type === 'air') {
                  this.airLoader = false
                  this.airVersion = null
                }
              }, 1000)
            }
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    copyTextToClipboard (id, value, event) {
      event.stopPropagation()
      const copyedText = value.toString()
      const textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        this.$root.$emit('bv::hide::tooltip', id)
        event.target.setAttribute('data-original-title', 'Скопировано')
        event.target.setAttribute('style', 'color: #40b539')
        this.$root.$emit('bv::show::tooltip', id)
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    resetTooltip (id, event) {
      this.$root.$emit('bv::hide::tooltip', id)
      event.target.setAttribute('data-original-title', 'Копировать')
      event.target.setAttribute('style', 'color: #78909C')
    }
  }
}
</script>

<style scoped lang="scss">
  img.client-logo {
    width: 28px;
    height: 28px;
  }
  .client-name {
    margin-bottom: 0;
    color: #37474F;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
  }
  i.fa-download.action {
    font-size: 18px;
    cursor: pointer;
    color: #78909c;
    &:hover {
      color: #40b539;
    }
  }
  i.fa-copy.action {
    font-size: 18px;
    cursor: pointer;
    color: #78909c;
  }
  .app-types-wrapper {
    max-width: 360px;
  }
</style>
